// removed by extract-text-webpack-plugin
module.exports = {"form":"c-PasswordRecoveryForm__form","button":"c-PasswordRecoveryForm__button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/PasswordRecoveryForm/PasswordRecoveryForm.scss
// module id = 586
// module chunks = 0